import React from "react";

const CandidateThirdForm = ({ setInputs, setStep, inputs }) => {

    console.log(inputs);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputs((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setStep(3);
    }

    const backButton = (event) => {
        event.preventDefault();
        setStep(1);
    }

    return (
        <form id="interim-third" onSubmit={handleSubmit}>
            <h3>Informations sur le compte</h3>
            <p>Ajoutez les informations de votre agence d'intérim.</p>
            <div>
                <label htmlFor="account_email" className="form-label">Email pour le compte l'agence</label>
                <input type="text" onChange={handleChange} placeholder="email" id="account_email" name="account_email"
                value={inputs["account_email"] !== null ? inputs["account_email"] : undefined}
                />
            </div>
            <div>
                <label htmlFor="password" className="form-label">Mot de passe</label>
                <input type="password" onChange={handleChange} placeholder="password" id="password" name="password"
                />
            </div>
            <div>
                <label htmlFor="confirm_password" className="form-label">Confirmer le mot de passe</label>
                <input type="password" onChange={handleChange} placeholder="password" id="confirm_password" name="confirm_password"
                />
            </div>
            <div>
                <button className="btn empty" onClick={backButton}>← Retour</button>
                <button type="submit" className="btn fill white">Suivant →</button>
            </div>
        </form>

    )
}

export default CandidateThirdForm;